angular
  .module('company')

  .directive('headquarterAddress', function() {
    return {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        headquarter: '=ngModel'
      },
      templateUrl: 'custom/company/views/partials/headquarterAddress.html'
    };
  });
